import { displayDates, getFormattedDate } from "../../../libs";

const timeFormat = "HH:mm";

type Props = {
  value: any;
  className?: string;
};

const DateAndTimeDisplay = ({ value, className }: Props) => (
  <time dateTime={value} className={className}>
    {`${displayDates({ value })} At ${getFormattedDate({
      format: timeFormat,
      date: value,
    })}`}
  </time>
);

export default DateAndTimeDisplay;
